import { fromStatusCodeToGenericError, httpService, WebRequestFactory } from "@pjs/http";
import { apiConfig } from "../../../ApiConfig";

export const extendTemporaryAccess = WebRequestFactory.createPatch<boolean, number, { tempAccessId: string }>({
    errorMapper: fromStatusCodeToGenericError,
    http: httpService,
    responseMapper: () => Promise.resolve(true),
    url: (params) => apiConfig.extendTemporaryAccess(params.tempAccessId)
});
